import React from "react";
import { useParams } from "react-router-dom";
import { URL } from "../../../../constants/URL";
import BreadCrumbs from "../../../common/breadcrumbs";
import { useGetRestaurantDetails } from "../../../../queryHooks";
import GiftsSettings from "./GiftsSettings";
import AccountingSettings from "./AccountingSettings";
import ContactDetails from "./ContactDetails";
import BasicDetails from "./BasicDetails";
import AddRestaurant from "./AddRestaurant";
import TaxSettings from "./TaxSettings";

//  Component starts
const RestaurantUpdate = () => {
	const { slug } = useParams();

	const { data: dataRestaurantDetails } = useGetRestaurantDetails(slug);

	return (
		<>
			{slug ? (
				<>
					<BreadCrumbs
						title={"Restaurant Management"}
						data={[
							{ label: "Restaurants", path: URL.restaurants },
							{
								label: dataRestaurantDetails?.data?.name || "",
								path: `${URL.restaurants}/${slug}`,
							},
							{ label: "Update Restaurant" },
						]}
					/>
					<BasicDetails />
					<GiftsSettings />
					<AccountingSettings />
					<TaxSettings />
					<ContactDetails />
				</>
			) : (
				<>
					<BreadCrumbs
						title={"Restaurant Management"}
						data={[
							{ label: "Restaurants", path: URL.restaurants },
							{ label: "Add Restaurant" },
						]}
					/>
					<AddRestaurant />
				</>
			)}
		</>
	);
};

export default RestaurantUpdate;
